import { createSlice } from "@reduxjs/toolkit";
import apiService from "../../api/apiService";
import { formatAxiosErrorMessage } from "../../utils/common";
import { endPoints } from "../../api/endpoints";
import { apiUrlBuilder } from "../../utils/util";


const WebhookIntegrationInitialState = {
    configuration: {
        isLoading: false,
        data: null,
        error: null,
    },
    createConfiguration: {
        isLoading: false,
        data: null,
        error: null,
    },
    updateConfiguration: {
        isLoading: false,
        data: null,
        error: null,
    },
    deleteConfiguration: {
        isLoading: false,
        data: null,
        error: null,
    },
};

export const WebhookSlice = createSlice({
    name: "webhookintegration",
    initialState: { ...WebhookIntegrationInitialState },
    reducers: {
        WebhookConfigurationRequesting: (state) => {
            state.configuration.isLoading = true;
        },
        WebhookConfigurationSuccess: (state, action) => {
            state.configuration.isLoading = false;
            state.configuration.error = null;
            state.configuration.data = action.payload.data;
        },
        WebhookConfigurationError: (state, action) => {
            state.configuration.isLoading = false;
            state.configuration.error = action.payload;
        },
        WebhookConfigurationReset: (state) => {
            state.configuration = WebhookIntegrationInitialState.configuration;
        },

        WebhookCreateConfigurationRequesting: (state) => {
            state.createConfiguration.isLoading = true;
        },
        WebhookCreateConfigurationSuccess: (state, action) => {
            state.createConfiguration.isLoading = false;
            state.createConfiguration.error = null;
            state.createConfiguration.data = action.payload.data;
        },
        WebhookCreateConfigurationError: (state, action) => {
            state.createConfiguration.isLoading = false;
            state.createConfiguration.error = action.payload;
        },
        WebhookCreateConfigurationReset: (state) => {
            state.createConfiguration = WebhookIntegrationInitialState.createConfiguration;
        },

        WebhookUpdateConfigurationRequesting: (state) => {
            state.updateConfiguration.isLoading = true;
        },
        WebhookUpdateConfigurationSuccess: (state, action) => {
            state.updateConfiguration.isLoading = false;
            state.updateConfiguration.error = null;
            state.updateConfiguration.data = action.payload.data;
        },
        WebhookUpdateConfigurationError: (state, action) => {
            state.updateConfiguration.isLoading = false;
            state.updateConfiguration.error = action.payload;
        },
        WebhookUpdateConfigurationReset: (state) => {
            state.updateConfiguration = WebhookIntegrationInitialState.updateConfiguration;
        },

        WebhookDeleteConfigurationRequesting: (state) => {
            state.deleteConfiguration.isLoading = true;
        },
        WebhookDeleteConfigurationSuccess: (state) => {
            state.deleteConfiguration.isLoading = false;
            state.deleteConfiguration.error = null;
            state.deleteConfiguration.data = "deleted";
        },
        WebhookDeleteConfigurationError: (state, action) => {
            state.deleteConfiguration.isLoading = false;
            state.deleteConfiguration.data = null;
            state.deleteConfiguration.error = action.payload;
        },
        WebhookDeleteConfigurationReset: (state) => {
            state.deleteConfiguration = WebhookIntegrationInitialState.deleteConfiguration;
        },
    },
});

export const WebhookConfigurationAPI = () => async (dispatch) => {
    dispatch(WebhookConfigurationRequesting());
    apiService
        .get(endPoints.integration.webhook.config, {})
        .then((response) => {
            dispatch(WebhookConfigurationSuccess(response.data));
        })
        .catch((error) => dispatch(WebhookConfigurationError(formatAxiosErrorMessage(error))));
};

export const WebhookCreateConfigurationAPI = (data) => async (dispatch) => {
    dispatch(WebhookCreateConfigurationRequesting());
    apiService
        .post(apiUrlBuilder(endPoints.integration.webhook.config, null, {}), data)
        .then((response) => {
            dispatch(WebhookCreateConfigurationSuccess(response.data));
        })
        .catch((error) => dispatch(WebhookCreateConfigurationError(formatAxiosErrorMessage(error))));
};

export const WebhookUpdateConfigurationAPI = (id, data) => async (dispatch) => {
    dispatch(WebhookUpdateConfigurationRequesting());
    apiService
        .put(apiUrlBuilder(`integration/${id}/webhook/config/`, null, {}), data)
        .then((response) => {
            dispatch(WebhookUpdateConfigurationSuccess(response.data));
        })
        .catch((error) => dispatch(WebhookUpdateConfigurationError(formatAxiosErrorMessage(error))));
};

export const WebhookDeleteConfigurationAPI = (id, force = false) => async (dispatch) => {
    dispatch(WebhookDeleteConfigurationRequesting());
    apiService
        .delete(apiUrlBuilder(`integration/${id}/webhook/config/`, null, { force }), {})
        .then((response) => {
            dispatch(WebhookDeleteConfigurationSuccess(response.data));
        })
        .catch((error) => dispatch(WebhookDeleteConfigurationError(formatAxiosErrorMessage(error))));
};

export const {
    WebhookConfigurationRequesting,
    WebhookConfigurationSuccess,
    WebhookConfigurationError,
    WebhookConfigurationReset,

    WebhookCreateConfigurationRequesting,
    WebhookCreateConfigurationSuccess,
    WebhookCreateConfigurationError,
    WebhookCreateConfigurationReset,

    WebhookUpdateConfigurationRequesting,
    WebhookUpdateConfigurationSuccess,
    WebhookUpdateConfigurationError,
    WebhookUpdateConfigurationReset,

    WebhookDeleteConfigurationRequesting,
    WebhookDeleteConfigurationSuccess,
    WebhookDeleteConfigurationError,
    WebhookDeleteConfigurationReset,
} = WebhookSlice.actions;

export const WebhookState = (state) => state.webhookIntegration;

export default WebhookSlice.reducer;
